<template>
    <Button :label="$t('edit_assign_transporter')" icon="pi pi-pencil" class="p-button-sm" style="background-color:var(--cyan-700)" @click="onShowMergeModal" />

    <CustomSidebar v-model:visible="showMergeModal" position="bottom" :dismissable="false" :title="$t('edit_assign_transporter')" class="p-1" :blocked="blocked">
        <template #actions>
            <Button icon="pi pi-save" class="p-button mr-1" style="background-color:var(--cyan-700)" :label="$t('edit_assign_transporter')" @click="save()"></Button>
        </template>
 
        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-4 md-4 p-fluid">
                <ScrollPanel style="width:100%;height:70vh">
                    <ModalData :data="header" v-if="header"/>
                </ScrollPanel>             
            </div>
            <Divider layout="vertical" />
            <div class="col-8 md-4 p-fluid">
                <ScrollPanel style="width:100%;height: 80vh">
                    <DataTable :value="details ? details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                        <Column field="sap_no" :header="$t('sap_no')"></Column>
                        <Column field="Item_No" :header="$t('item_no')" key="Item_No">  
                        </Column>
                        <Column field="Material_Name" header="Material" key="material_name" >
                        </Column>
                        <Column field="Qty" :header="$t('qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="order_qty" :header="$t('order_qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="sap_os_qty" :header="$t('sap_order_os_qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                         <Column field="real_qty" :header="$t('real_qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                {{this.$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" style="width:10%">
                        </Column>
                    </DataTable>

                    <Divider />

                    <div class="grid">
                        <div class="col-12">
                            <div class="field grid">
                                <label class="col-2">&nbsp;</label>
                                <div class="col-4 md-4">
                                    <Tag value="Current" class="w-full text-lg" ></Tag>
                                </div>
                                <div class="col-4 md-4">
                                    <Tag value="Change" class="w-full text-lg" severity="success"></Tag>
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Truck_Type_Id" class="col-2">{{$t('shipment_type')}}</label>
                                <div class="col-4 md-4">
                                    <CustomSelect :placeholder="$t('shipment_type')" class="p-inputtext-sm" v-model="header.Shipment_Type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.SHIPMENT_TYPE}" v-if="header" :filter="true" disabled/>
                                </div>
                                <div class="col-4 md-4">
                                    <CustomSelect :placeholder="$t('shipment_type')" class="p-inputtext-sm" v-model="assignModel.shipment_type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.SHIPMENT_TYPE}" v-if="assignModel" :filter="true" :disabled="!can_edit_assign"/>
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Vessel" class="col-2">{{$t('vessel')}}</label>
                                <div class="col-4 md-4">
                                    <InputText name="Vessel" type="text" v-model="header.Vessel" v-if="header" disabled/>
                                </div>
                                <div class="col-4 md-4">
                                    <InputText name="Vessel" type="text" v-model="assignModel.vessel" v-if="assignModel" :disabled="!can_edit_assign"/>
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Loading" class="col-2">{{$t('loading')}}</label>
                                <div class="col-4 md-4">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.Loading_Destination_From_Id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="header" :filter="true" :disabled="true"/>
                                </div>
                                <div class="col-4 md-4">
                                    <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_from_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :disabled="!can_edit_assign" :filter="true"/>
                                    <!-- <InputText name="Location" type="text" v-model="assignModel.loading_destination_from_id" v-if="assignModel" :disabled="!can_edit_assign"/> -->
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Destination" class="col-2">{{$t('destination')}}</label>
                                <div class="col-4 md-4">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.Loading_Destination_To_Id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="header" :filter="true" :disabled="true"/>
                                </div>
                                <div class="col-4 md-4">
                                    <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_to_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :disabled="!can_edit_assign" :filter="true"/>
                                    <!-- <InputText name="Location" type="text" v-model="assignModel.loading_destination_to_id" v-if="assignModel" :disabled="!can_edit_assign"/> -->
                                </div>
                            </div>
<!-- 
                            <FormField :labelName="$t('charge_oa_company')" fieldName="Charge_OA_Company" v-model="header" fieldClass="col-8" labelClass="col-2">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Charge_OA_Company" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }" v-if="header" :filter="true" :disabled="true"/>
                            </FormField> -->

                            <FormField :labelName="isRelation ? $t('customer_vendor') : $t('transporter')" fieldName="Transporter_Code" v-model="header" fieldClass="col-8" labelClass="col-2">
                                <InputText name="Transporter_Code" type="text" disabled v-model="transporterName" v-if="header"/>
                            </FormField>
                            
                            <FormField :labelName="$t('truck_type')" fieldName="Truck_Type_Id" v-model="header" fieldClass="col-8" labelClass="col-2">
                                <CustomSelect class="p-inputtext-sm" v-model="header.Truck_Type_Id" :url="this.$API_URL + 'list/truck_type'" :minLength="0" :params="{ }" v-if="header" disabled />
                            </FormField>

                            <div class="field grid">
                                <label for="Freight_Cost" class="col-2">{{$t('freight_cost')}}</label>
                                <div class="col-4 md-4">
                                    <InputNumber name="Freight_Cost" mode="decimal" :optionalDecimal="true" v-model="header.Freight_Cost" v-if="header" :disabled="true"/>
                                </div>
                                <div class="col-4 md-4">
                                    <InputNumber name="Freight_Cost" mode="decimal" :optionalDecimal="true" v-model="transporter.freight_cost" v-if="transporter" @blur="onFreightCostChange($event)" :disabled="!can_edit_assign"/>
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Freight_Container" class="col-2">{{$t('user_num_trip')}}</label>
                                <div class="col-4 md-4">
                                    <div class="p-inputgroup">
                                        <InputNumber name="Freight_Container" mode="decimal" :optionalDecimal="true" v-model="header.User_NoT" v-if="header" :disabled="true" />
                                        <span class="p-inputgroup-addon" v-if="header" style="padding-left:2rem; padding-right:2rem;">{{header.Freight_Cost_UOM}}</span>
                                    </div>
                                </div>
                                <div class="col-4 md-4">
                                    <div class="p-inputgroup">
                                        <InputNumber name="Freight_Container" mode="decimal" :optionalDecimal="true" v-model="transporter.user_not" v-if="transporter" :disabled="!transporter.freight_value || !can_edit_assign"  @blur="onUserNumTripChange($event)"/>
                                        <span class="p-inputgroup-addon" v-if="header" style="padding-left:2rem; padding-right:2rem;">{{header.Freight_Cost_UOM}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Freight_Total_Cost_User_NoT" class="col-2">{{$t('freight_total_cost_user_not')}}</label>
                                <div class="col-4 md-4">
                                    <InputNumber name="Freight_Total_Cost_User_NoT" mode="decimal" :optionalDecimal="true" v-model="header.Freight_Total_Cost_User_NoT" v-if="header" :disabled="true" />
                                </div>
                                <div class="col-4 md-4">
                                    <InputNumber name="Freight_Total_Cost_User_NoT" mode="decimal" :optionalDecimal="true" v-model="transporter.freight_total_cost_user_not" v-if="transporter" :disabled="true" />
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Freight_Master" class="col-2">{{$t('freight_master')}}</label>
                                <div class="col-4 md-4">
                                    <InputText name="Freight_Master" v-model="header.freight_master" v-if="header" :disabled="true" />
                                </div>
                                <div class="col-4 md-4">
                                    <InputText name="Freight_Master" v-model="transporter.freight_master" v-if="transporter" :disabled="true" />
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Assign_Reason" class="col-2">{{$t('assign_reason')}}</label>
                                <div class="col-4 md-4">
                                    <CustomSelect class="p-inputtext-sm" v-model="header.Assign_Reason" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.ASSIGN_TRANSPORTER_REASON }" v-if="header" disabled />
                                </div>
                                <div class="col-4 md-4">
                                    <CustomSelect class="p-inputtext-sm" v-model="transporter.assign_reason" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.ASSIGN_TRANSPORTER_REASON }" v-if="transporter" @change="onAssignReasonChange($event)" :disabled="!transporter.require_reason"  />
                                </div>
                            </div>

                            <div class="field grid">
                                <label for="Assign_Reason_Others" class="col-2">&nbsp;</label>
                                <div class="col-4 md-4">
                                    <Textarea :autoResize="true" rows="5" v-if="header" v-model="header.Assign_Reason_Others" :disabled="true"/>
                                </div>
                                <div class="col-4 md-4">
                                    <Textarea :autoResize="true" rows="5" v-if="transporter" v-model="transporter.assign_reason_others" :disabled="!requireReasonOthers"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </ScrollPanel>
            </div>
        </div>
    </CustomSidebar>    
</template>
<script>
    import ModalData from '../Helper/_ModalData.vue'

    export default{
        components: {
            'ModalData': ModalData,
        },
        emits:['close', 'block', 'unblock'],
        props:{
            data: {
                type: Array,
                default: []
            },
            dataRelation:{
                type: Boolean,
                default:null
            }
        },
        data(){
            return{
                showMergeModal: false,
                dataUrl: "order/",
                dataUrlOrder: "order/",
                blocked:false,
                header: null,
                header1: null,
                details: [],
                requireReasonOthers: false,
                assignModel: null,
                transporter: null,
                sapOrderIds: [],

                transporterName: "",
                orderTypeCode: "",
                orderTypeInfo1: ""
            }
        },
        mounted(){
            
        },
        methods:{
            reset(){
                this.header = null;
                this.header1 = null;
                this.details = [];
                this.assignModel = null;
                this.transporterName = "";
                this.transporter = null;
                this.sapOrderIds = [];
                // this.orderTypeCode =  "";
                // this.orderTypeInfo1 =  "";
            },
            blockModal(){
                this.blocked = true;
            },
            unblockModal(){
                this.blocked = false;
            },
            onShowMergeModal(){
                this.reset();

                var self = this;
            
                this.blocked = false;
                this.showMergeModal = true;

                this.$axios.get(this.$API_URL + this.dataUrlOrder + this.data[0].Id + "/" + this.$FORM_MODE_EDIT )
                    .then((response) => {
                        if(response){
                            if(response.data.success){
                                self.header = response.data.data.header;
                                self.header1 = {...self.header};
                                
                                self.transporterName = "[" + self.header.Transporter_Code + "] " + self.header.Transporter_Name;
 
                                self.details = self.header.Details;
                                self.sapOrderIds = self.header.sap_order_ids;
                                self.assignModel = response.data.data.assign;

                                var det = { ...self.assignModel.transporters };
                                self.transporter = det;

                                self.assignModel.charge_oa_company = self.header.Company_Code;
                                self.assignModel.warehouse_code = self.header.Warehouse_Code;
                                self.assignModel.document_type = self.header.Document_Type;
                                self.assignModel.loading_destination_from_id = self.header.Loading_Destination_From_Id;
                                self.assignModel.loading_destination_to_id = self.header.Loading_Destination_To_Id;
                                self.assignModel.shipment_type = self.header.Shipment_Type;
                                self.assignModel.vessel = self.header.Vessel;
                                self.assignModel.freight_date = self.header.Freight_Date;
                                self.assignModel.trip_type = self.header.Trip_Type;

                                self.transporter.transporter_code = self.header.Transporter_Code;
                                self.transporter.transporter_name = self.header.Transporter_Name;
                                self.transporter.truck_type_id = self.header.Truck_Type_Id;
                                self.transporter.freight_cost = self.header.Freight_Cost;
                                self.transporter.freight_total_cost = self.header.Freight_Cost;
                                self.transporter.freight_total_cost_user_not = self.header.Freight_Total_Cost_User_NoT;
                                self.transporter.freight_suggested = self.header.Freight_Cost;
                                self.transporter.freight_container = self.header.User_NoT;
                                self.transporter.freight_uom = self.header.Freight_Cost_UOM;
                                self.transporter.freight_value = self.header.Freight_Cost_Value;
                                self.transporter.freight_master = self.header.freight_master;
                                self.transporter.system_not = self.header.System_NoT;
                                self.transporter.user_not = self.header.User_NoT;
                                self.transporter.assign_reason = self.header.Assign_Reason;
                                self.transporter.assign_reason_others = self.header.Assign_Reason_Others;


                                self.getOrderType();
                            }
                            else{
                                
                            }
                        }
                    })
                    .catch(function(err){

                    })
            },
            getOrderType(){
                var self = this;
                var id = self.data[0].Order_Type_Id;
                this.$axios.get(this.$UTIL_URL + "order_type_fields?id=" + id)
                    .then((response) => {
                        self.orderTypeCode = response.data.data.Code;
                        self.orderTypeInfo1 = response.data.data.Info1;
                    })
                    .catch((error) => {
                        self.showError('Error Getting Order Type Data', error);
                    });
            },
            showError(summary, message) {
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            }, 
            save(){
                var self = this;
                this.blocked = true;

                this.assignModel.transporters.push(this.transporter);

                var data = {
                    id: this.header.Id,
                    edited_order: this.assignModel,
                };

                this.$axios.put(this.$API_URL + this.dataUrlOrder + "edit_assign_transporter", data)
                    .then((response) =>{
                        if (response.data.success) {
                            self.$emit('close');
                            self.$parent.$toast.add({ severity: 'success', summary: "Success", detail: response.data.message, life: 120000});
                            self.showModal = false;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                        self.blocked = false;
                    })
                    .catch((err) => {
                        //console.log(err);
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        self.showModal = false;
                    });
            },
            disableQtyInput(event){
                return this.isCollective || this.useLN; //|| (!event.data.collective_ln && this.orderType == "LN");
            },
            onChangeQty(event, index){
                var model = this.details[index];
                model.Qty = event.valueNumber;
                this.$nextTick(() => {
                    this.changeQty();

                });
            },
            onCheckChanged(index){
                if(this.details.length > 0){
                    var checkedCount = this.details.filter(w => w.include_merge)
                    if(checkedCount.length == 0){
                        this.details[index].include_merge = true;
                    }
                }
            },
            itemEditable(event){
                return !event.data.editable;
            },
            changeQty(){
                this.blocked = true;

                var self = this;

                var data = {
                    order_id: this.data[0].Id,
                    details: this.details
                };

                this.$axios.post(this.$API_URL + "util/refresh_freight_cost_order", data)
                    .then((response) => {
                        if(response){
                            var data = response.data.data;

                            var model = this.transporters[0];
                            // model.transporter_name = data.transporter_name;
                            // model.transporter_code = data.transporter_code;
                            // model.freight_cost = data.cost;
                            // //model.freight_suggested = data.cost;
                            // model.freight_value = data.is_value;
                            // model.freight_per = data.per;
                            // model.truck_type_id = data.truck_type_id;
                            // model.freight_uom = data.is_value ? data.numtrip : data.uom;
                            model.freight_total_cost_user_not = data.total_cost_user_not;
                            model.freight_total_cost = data.total_cost;
                            model.freight_master = data.master_cost;
                            // model.truck_capacity = data.freight_capacity;
                            // model.freight_kg = data.total_kg_user;
                            // model.system_not = data.system_not;
                            model.freight_material = data.materials;
                            // var container = this.selectTransporterNumTrip;
                            // model.freight_container = container;
                        }
                        self.blocked = false;
                    })
                    .catch(function (err) {
                        self.$showToast({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                    });
            },
            onAssignReasonChange(event, index){
                if(event){
                    var requireOthers = event.Lookup_Info1 == "Y";
                    this.requireReasonOthers = requireOthers;
                }               
            },
            transporterModel(){
                var loading = this.assignModel.loading_destination_from_id;
                var destination = this.assignModel.loading_destination_to_id;
                var chargeOACompany = this.assignModel.charge_oa_company;
                var warehouseCode = this.assignModel.warehouse_code;
                var documentType = this.assignModel.document_type;
                var freightDate = this.assignModel.freight_date;

                var selected = [];
                selected.push(this.transporter);
                

                var data = {
                    loading: loading,
                    destination: destination,
                    exclude_transporters: [],
                    materials: this.details,
                    container: this.transporter.user_not,
                    charge_oa_company: chargeOACompany,
                    warehouse_code: warehouseCode,
                    document_type: documentType,
                    freight_date: freightDate,
                    sap_order_ids: this.sapOrderIds,
                    selected_transporters: selected, //includeTransporters ? this.transporters : [],
                    trip_type: this.assignModel.trip_type
                };

                return data;
            },
            onUserNumTripChange(event){
                var model = this.transporter;
                var number = event.valueNumber;
                model.freight_container = number;
                this.$nextTick(() => {
                    this.refreshFreightCost(model);
                });
            },
            onFreightCostChange(event){
                var model = this.transporter;
                var number = event.valueNumber;

                if(number == model.freight_cost)
                    return;

                model.freight_cost = event.value;
                if(!model.freight_criteria){
                    model.require_reason = parseFloat(model.freight_cost) > parseFloat(model.freight_suggested);
                }
                else{
                    model.require_reason = true;
                }      

                this.$nextTick(() => {
                    this.refreshFreightCost(model);
                });
                
            },
            refreshFreightCost(nmodel){
                var self = this;

                self.blocked= true;
                
                if(nmodel.transporter_code){
                    this.$emit("block");
                    this.$axios.post(this.$API_URL + "util/refresh_freight_cost", this.transporterModel(true))
                        .then((response) => {
                            if(response){
                                var data = response.data.data[0];

                                var model = this.transporter;
                                model.transporter_name = data.transporter_name;
                                model.transporter_code = data.transporter_code;
                                model.freight_cost = data.cost;
                                //model.freight_suggested = data.cost;
                                //model.freight_value = data.is_value;
                                //model.freight_per = data.per;
                                model.truck_type_id = data.truck_type_id;
                                model.freight_uom = data.is_value ? data.numtrip : data.uom;
                                model.freight_total_cost_user_not = data.total_cost_user_not;
                                model.freight_total_cost = data.total_cost;
                                model.freight_master = data.master_cost;
                                // model.truck_capacity = data.freight_capacity;
                                // model.freight_kg = data.total_kg_user;
                                // model.system_not = data.system_not;
                                // model.freight_material = data.materials;
                                // var container = this.selectTransporterNumTrip;
                                // model.freight_container = container;
                            }
                            self.blocked = false;
                        })
                        .catch(function (err) {
                            self.$showToast({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                            self.blocked = false;
                        });
                }
            },
        },
        computed:{
            materialDataModel(){
                var model = [];

                for(var i =0; i< this.sapOrdersDetail.length;i++){
                    var detail = this.sapOrdersDetail[i];
                    model.push({
                        Id: detail.Id,
                        Item_No: detail.Item_No,
                        Material_Code: detail.Material_Code,
                        Material_Name: "",
                        Qty: detail.Qty,
                        UOM: detail.UOM,
                        Freight_Master: 0,
                        Freight_Cost:0,
                        Freight_Per: "",
                        Freight_UOM:""
                    });
                }

                return model;
            },
            orderList(){
                var list = [];

                if(this.sapOrders.length == 0) return list;

                return this.sapOrders.map(function(v) {
                            return v.Id;
                        });
            },
            can_edit_assign(){
                if(this.orderTypeCode == "TO" && this.orderTypeInfo1 == "IN"){
                    return false;
                }

                return true;
            }
        }


    }

</script>

